<div class="p-3">
  <form [formGroup]="searchForm" autocomplete="off">
    <div class="row align-items-center w-100">
        <div class="col-md-2 mt-1">
            <input type="text" class="form-control input-default" placeholder="Name" formControlName="name"/>
        </div>
        <div class="col-md-2 mt-1 md-1">
            <select class="form-select" (change)="handleSearch('')" formControlName="status">
                <option value="null" disabled selected>Status</option>
                <option value="Pending">Pending</option>
                <option value="Paid">Paid</option>
                <option value="Unpaid">Unpaid</option>
                <option value="Cancelled">Cancelled</option>
            </select>

        </div>
        <div class="col-md-3 mt-1">
            <select class="form-select" formControlName="bill_type" (change)="handleSearch('')">
                <option value="null" disabled selected >Type</option>
                <option *ngFor="let billType of defaultBillTypes" [value]="billType.key">{{billType.keyName}}</option>
                <!-- <option value="2">Expense</option>
                <option value="3">Company Income</option>
                <option value="4">Company Expense</option>             -->
            </select>
        </div>
        <!-- <div class="col-md-2 mt-1">
            <select class="form-select" formControlName="role_identifier" (change)="handleSearch('')">
                <option value="null" disabled selected>Recipient</option>
                <option value="property_manager">Property Manager</option>
                <option value="owner">Owner</option>
                <option value="tenant">Tenant</option>
            </select>
        </div> -->
        <div class="col-md-3 mt-1">
          <!-- <a class="btn btn-danger btn-sm me-3 float-end" href="javascript:void(0);" (click)="clearBills()">Clear</a> -->
           <button class="btn btn-danger btn-sm  me-3 float-end"  type="button" (click)="clearBills()" [disabled]="!disableClear">Clear</button>
          <a *ngIf="checkAddBill" class="btn btn-primary btn-sm me-5 float-end" href="javascript:void(0);" (click)="addPropertyBills()">Add Bill</a>
        </div>
        <div class="col-md-4 d-none">
            <mat-form-field class="mb-3">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="picker1">
                  <input matStartDate  placeholder="Start date">
                  <input matEndDate placeholder="End date">
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-date-range-picker #picker1></mat-date-range-picker>
              </mat-form-field>
        </div>
      </div>
    </form>
    <div class="row d-none">
        <div class="col-md-12 col-xs-12 mt-2">
            <a class="btn btn-primary btn-sm me-3 mb-3 float-end" data-bs-toggle="offcanvas" data-bs-target="#add_property_bills"  href="javascript:void(0);" (click)="addPropertyBills()">Add Bill</a>
            <a class="btn btn-danger btn-sm me-3 mb-3 float-end" href="javascript:void(0);" >Clear</a>
        </div>
    </div>

    <div class="row mt-2">
      <div class="col-xl-12">
        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper">
          <table id="empoloyees-tbl" class="table mb-0">
            <thead>
              <tr>
                <th>Bill Name</th>
                <th>Paid Date</th>
                <th>Bill Type</th>
                <th class="category-width">Category</th>
                <th>Bill Amount</th>
                <th>Creation Date</th>
                <th>Payment Status</th>
                <th class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let bill of allData.data">
                <td>
                  <span>{{ bill.name }}</span>
                </td>
                <td>
                  <span>{{ bill.paid_date | date:'dd-MM-yyyy' }}</span>
                </td>
                <td>
                  <span>{{ bill.billTypeName }}</span>
                </td>
                <td>
                  <span>{{ bill.category }}</span>
                </td>
                <td>
                  <span>{{ bill.amount }}</span>
                </td>
                <td>
                  <span>{{ bill.created_at | date:'dd-MM-yyyy' }}</span>
                </td>
                <td>
                  @if(bill.status == 'Pending'){
                  <span class="badge light badge-info me-2">Pending</span>
                  } @else if(bill.status == 'Paid'){
                  <span class="badge light badge-success me-2">Paid</span>
                  } @else if(bill.status == 'Unpaid'){
                  <span class="badge light badge-warning me-2">Unpaid</span>
                  } @else {
                  <span class="badge light badge-danger me-2">Cancelled</span>
                  }

                </td>
                <td>

                  <div class="img-wrapper" *ngIf="checkViewBill">
                    <button type="button" class="btn btn-primary shadow btn-xs sharp me-2" (click)="viewBill(bill.uid)">
                      <i class="fa fa-eye"></i>
                    </button>
                    <div class="tooltip-text">View</div>
                  </div>

                  <div class="img-wrapper" *ngIf="!bill.invoice_generated && bill.status !='Paid' && checkEditBill">
                    <button type="button" class="btn btn-success shadow btn-xs sharp me-2" (click)="editBill(bill.uid)">
                      <i class="fa fa-edit"></i>
                    </button>
                    <div class="tooltip-text">Edit</div>
                  </div>
                  <div class="img-wrapper" *ngIf="bill.status =='Paid' && bill.taxable && !bill.invoice_generated && checkGenerateInvoice">
                    <button type="button" class="btn btn-dark shadow btn-xs sharp me-2" (click)="generateInvoice(bill.uid)">
                      <i class="fa fa-file-pdf"></i>
                    </button>
                    <div class="tooltip-text">Invoice Generate</div>
                  </div>
                  <div class="img-wrapper" *ngIf="checkViewInvoice">
                    <button type="button" class="btn btn-info shadow btn-xs sharp me-2" (click)="viewInvoice(bill.uid)">
                      <i class="fa fa-download"></i>
                    </button>
                    <div class="tooltip-text">Download</div>
                  </div>
                  <div class="img-wrapper" *ngIf="checkRegenerateInvoice">
                    <button type="button" class="btn btn-success shadow btn-xs sharp me-2" (click)="regenerateInvoice(bill.uid)">
                      <i class="fa fa-refresh"></i>
                    </button>
                    <div class="tooltip-text">Regenerate</div>
                  </div>
                  <div class="img-wrapper" *ngIf="checkDeleteBill && !bill.invoice_generated">
                    <button type="button" class="btn btn-danger shadow btn-xs sharp me-2" (click)="deleteBill(bill.uid)">
                      <i class="fa fa-trash"></i>
                    </button>
                    <div class="tooltip-text">Delete</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="dataTables_info" id="example5_info" role="status" aria-live="polite" *ngIf="allData.data?.length">
            Showing
            {{allData.startPage}} to
            {{allData.endPage}} of {{ totalPage }} entries
          </div>
          <div class="dataTables_paginate paging_simple_numbers pt-2" *ngIf="allData.data?.length">
            <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)"></app-pagination>
          </div>
        </div>
      </div>
    </div>
</div>

